import "./BiomarkerDetailsComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import commonService from "../../../shared/services/common.service";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import {CommonService} from "../../../shared/services";
import {IAPIResponseType} from "../../../shared/models/api.model";
import {ImageConfig} from "../../../constants";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import StatusCardComponent from "../../../shared/components/status-card/statusCardComponent";
import HeadingComponent from "../../../shared/components/heading/headingComponent";
import DetailsDataKeyValueComponent
    from "../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import TabsWrapperComponent, {
    TabComponent,
    TabContentComponent,
    TabsComponent
} from "../../../shared/components/tabs/tabsComponent";
import BiomarkerBasicDetailsViewEditComponent
    from "./biomarker-basic-details-view-edit/BiomarkerBasicDetailsViewEditComponent";
import BiomarkerReportConfigurationViewEditComponent
    from "./biomarker-report-configuration-view-edit/BiomarkerReportConfigurationViewEditComponent";

interface BiomarkerDetailsComponentProps {

}

const BASIC_DETAILS = 'basic-details';
const REPORT_CONFIGURATION = 'report-configuration';
// const ATTACHMENTS = 'attachments';

const BiomarkerDetailsComponent = (props: BiomarkerDetailsComponentProps) => {

    const [activeTab, setActiveTab] = useState<'basic-details' | 'report-configuration' | 'attachments' >(BASIC_DETAILS);
    const navigate = useNavigate();
    const params = useParams<{ biomarkerId: string | undefined }>();
    const {biomarkerId} = params;
    const [biomarkerDetails, setBiomarkerDetails] = useState<any>(undefined);
    const [isBiomarkerDetailsLoading, setIsBiomarkerDetailsLoading] = useState<boolean>(false);
    const [isBiomarkerDetailsLoaded, setIsBiomarkerDetailsLoaded] = useState<boolean>(false);
    const [isBiomarkerDetailsLoadingFailed, setIsBiomarkerDetailsLoadingFailed] = useState<boolean>(false);
    const dispatch = useDispatch();
    const [biomarkerDetailsMode, setBiomarkerDetailsMode] = useState<"view" | "edit">("view");
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const [canEdit, setCanEdit] = useState<boolean>(false);

    useEffect(() => {
        setCanEdit(commonService.checkAccess('Biomarker',
            "biomarkerEdit", currentUser?.userAccessModules))
    }, [currentUser]);

    useEffect(() => {
        if (biomarkerId) {
            dispatch(setCurrentNavParams("Back", "Biomarkers", CommonService._routeConfig.BiomarkerListRoute()));
            dispatch(setSideMenuView('compact'));
        }
    }, [biomarkerId, dispatch, navigate]);

    const getBiomarkerDetails = useCallback(() => {
        const payload = {};
        let biomarkerDetails: any = {};
        setIsBiomarkerDetailsLoading(true);
        setIsBiomarkerDetailsLoaded(false);
        setIsBiomarkerDetailsLoadingFailed(false);
        CommonService._biomarker.getBiomarkerDetails(biomarkerId, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    biomarkerDetails = response.data;
                }
                setBiomarkerDetails(biomarkerDetails);
                setIsBiomarkerDetailsLoading(false);
                setIsBiomarkerDetailsLoaded(true);
                setIsBiomarkerDetailsLoadingFailed(false);
            })
            .catch((error: any) => {
                setBiomarkerDetails(biomarkerDetails);
                setIsBiomarkerDetailsLoading(false);
                setIsBiomarkerDetailsLoaded(false);
                setIsBiomarkerDetailsLoadingFailed(true);
            });
    }, [biomarkerId]);

    useEffect(() => {
        if (biomarkerId) {
            getBiomarkerDetails();
        }
    }, [biomarkerId, getBiomarkerDetails])

    const handleBiomarkerDetailsUpdate = useCallback((biomarkerBasicDetails: any) => {
        setBiomarkerDetails(() => {
            return {
                ...biomarkerBasicDetails
            }
        });
    }, []);



    const handleActiveTabChange = useCallback((value: any) => {
        if (biomarkerDetailsMode === 'edit') {
            CommonService.openConfirmationDialog(
                {
                    confirmationTitle: 'Please confirm!',
                    confirmationSubTitle: 'Are you sure you want to discard the recent changes?',
                    disableEscKeyClose: false,
                    disableBackdropClose: true,
                    imagePath: `${ImageConfig.ConfirmationImage}`,
                    direction: "up",
                    yes: {
                        text: "Discard",
                        color: "primary"
                    },
                    no: {
                        text: "Cancel",
                        color: "primary"
                    }
                }).then(() => {
                setActiveTab(value);
            }).catch(() => {

            })
        } else {
            setActiveTab(value);
        }
    }, [biomarkerDetailsMode])

    return (
        <div className={'biomarker-details-component  details-screen screen'}>
            {
                isBiomarkerDetailsLoading && <div className="h-v-center">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                isBiomarkerDetailsLoadingFailed && <>
                    <StatusCardComponent title={"Biomarker details failed to load"}/>
                </>
            }
            {
                isBiomarkerDetailsLoaded && <>
                    <div className={'details-module-title'}>Biomarker Details</div>
                    <div className="basic-details-wrapper">
                        <div className="details-screen-header">
                            <HeadingComponent title={CommonService.capitalizeFirstLetter(biomarkerDetails?.name)}
                            />
                        </div>
                        <div className="details-screen-sub-header">
                            <DetailsDataKeyValueComponent
                                title={"Biomarker ID:"}
                                isHorizontal={true}>
                                <>{biomarkerDetails?.id}</>
                            </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Added by:"}
                                isHorizontal={true}>
                                <>{CommonService.getFullName(biomarkerDetails?.createdByDetails)}</>
                            </DetailsDataKeyValueComponent>
                            <DetailsDataKeyValueComponent
                                title={"Created on:"}
                                isHorizontal={true}>
                                <>
                                    {commonService.formatDate(biomarkerDetails?.createdAt)}
                                    &nbsp;|&nbsp;
                                    {commonService.formatTime(biomarkerDetails?.createdAt)}
                                </>
                            </DetailsDataKeyValueComponent>
                        </div>
                    </div>
                    <div className="clear-fix"/>
                    <div className="details-screen-body">
                        <TabsWrapperComponent>
                            <TabsComponent
                                value={activeTab}
                                allowScrollButtonsMobile={false}
                                onUpdate={(e: any, v: any) => {
                                    handleActiveTabChange(v)
                                }}
                                variant={"fullWidth"}
                            >
                                <TabComponent label="BASIC DETAILS" value={BASIC_DETAILS}/>
                                <TabComponent label="REPORT CONFIGURATION" disabled={!CommonService.isReadOnlyFeature()} value={REPORT_CONFIGURATION}/>
                                {/*<TabComponent label="ATTACHMENTS" value={ATTACHMENTS}/>*/}
                            </TabsComponent>

                            <TabContentComponent selectedTab={activeTab} value={BASIC_DETAILS}>
                                <BiomarkerBasicDetailsViewEditComponent
                                    biomarkerDetails={biomarkerDetails}
                                    canEdit={canEdit}
                                    onModeChange={(mode: any) => {
                                        setBiomarkerDetailsMode(mode);
                                    }
                                    }
                                    onUpdateBiomarkerDetails={handleBiomarkerDetailsUpdate}
                                />
                            </TabContentComponent>

                            <TabContentComponent selectedTab={activeTab} value={REPORT_CONFIGURATION}>
                                <BiomarkerReportConfigurationViewEditComponent
                                    biomarkerDetails={biomarkerDetails}
                                    onUpdateBiomarkerDetails={handleBiomarkerDetailsUpdate}
                                    // canEdit={canEdit}
                                    // onModeChange={(mode: any) => {
                                    //     setBiomarkerDetailsMode(mode);
                                    // }
                                    // }
                                />
                            </TabContentComponent>

                            {/*<TabContentComponent selectedTab={activeTab} value={ATTACHMENTS}>*/}
                            {/*    <BiomarkerAttachmentsViewEditComponent*/}
                            {/*        biomarkerDetails={biomarkerDetails}*/}
                            {/*        canEdit={canEdit}*/}
                            {/*        onModeChange={(mode: any) => {*/}
                            {/*            setBiomarkerDetailsMode(mode);*/}
                            {/*        }*/}
                            {/*        }*/}
                            {/*    />*/}
                            {/*</TabContentComponent>*/}
                        </TabsWrapperComponent>
                    </div>
                </>
            }
        </div>
    );

};

export default BiomarkerDetailsComponent;
